import { motion } from "framer-motion";
import GoldButton from "../GoldButton";
import { BRAND } from "../../data/content";

export default function CTABand() {
    return (
        <section
            className="relative overflow-hidden bg-[#0B0B0C] border-t border-[rgba(201,168,106,0.15)]"
            data-testid="cta-band"
        >
            {/* Subtle gold glow accent, no white bleed */}
            <div
                aria-hidden="true"
                className="pointer-events-none absolute inset-0"
            >
                <div className="absolute -top-40 left-1/2 -translate-x-1/2 h-[600px] w-[900px] max-w-[180vw] rounded-full bg-[#C9A86A]/10 blur-[140px]" />
                <div className="absolute inset-0 bg-gradient-to-b from-[#0B0B0C]/40 via-[#0B0B0C]/80 to-[#0B0B0C]" />
            </div>

            <div className="relative shell py-24 md:py-32 lg:py-40 flex flex-col items-center text-center">
                <motion.span
                    suppressHydrationWarning
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.9 }}
                    className="eyebrow"
                >
                    Private Consultation
                </motion.span>

                <motion.h2
                    suppressHydrationWarning
                    initial={{ opacity: 0, y: 16 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                    className="mt-8 font-serif text-5xl md:text-6xl lg:text-7xl leading-[1.05] max-w-4xl"
                >
                    {"Begin the "}
                    <span className="italic text-[#C9A86A]">Conversation.</span>
                </motion.h2>

                <motion.p
                    suppressHydrationWarning
                    initial={{ opacity: 0, y: 12 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{
                        duration: 0.9,
                        delay: 0.15,
                        ease: [0.22, 1, 0.36, 1],
                    }}
                    className="mt-8 max-w-xl text-[#9A958A] text-base md:text-lg leading-[1.85]"
                >
                    Every engagement begins with a private conversation — often
                    under NDA, always without obligation. We would be honored
                    to hear about the residence you are composing.
                </motion.p>

                <motion.div
                    suppressHydrationWarning
                    initial={{ opacity: 0, y: 12 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{
                        duration: 0.9,
                        delay: 0.25,
                        ease: [0.22, 1, 0.36, 1],
                    }}
                    className="mt-12 flex flex-col sm:flex-row gap-4"
                >
                    <GoldButton to="/contact" testId="cta-band-book">
                        Book a Consultation
                    </GoldButton>
                    <GoldButton
                        href={BRAND.phoneHref}
                        variant="outline"
                        testId="cta-band-call"
                    >
                        Call {BRAND.phone}
                    </GoldButton>
                </motion.div>
            </div>
        </section>
    );
}
